import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CreateTipoCasoRequest } from '@models/tipoCaso/createTipoCasoRequest.model';
import { UpdateTipoCasoRequest } from '@models/tipoCaso/updateTipoCasoRequest.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class TipoCasoService {

  constructor(private http:HttpClient) {
  }

  create(createTipoCasoRequest:CreateTipoCasoRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/TipoCaso/Create",createTipoCasoRequest);
  }

  update(updateTipoCasoRequest:UpdateTipoCasoRequest):Observable<any>
  {
    return  this.http.put<any>("/api/TipoCaso/Update",updateTipoCasoRequest);
  }

  getAll():Observable<BaseDto[]> {
    return   this.http.get<BaseDto[]>("/api/TipoCaso/GetAll");
  }

  getById(id:number):Observable<BaseDto>{
    return  this.http.get<BaseDto>("/api/TipoCaso/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/TipoCaso/Delete?id=" + id);
    else
      return of(null)
  }
}
